import React from "react"
import clsx from "clsx"
//import I18n from "i18n-js/index.js.erb"

class PaymentGatewayTesterSteps extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    // icon classes
    var credentialsIconClasses = clsx({
      icon: true,
      "spinner": this.props.currentStep === 'credentials',
      "ss-lightning": this.props.gateway && this.props.gateway.credentials_step === null && this.props.currentStep !== 'credentials',
      "ss-alert": this.props.gateway && this.props.gateway.credentials_step === false,
      "ss-check": this.props.gateway && this.props.gateway.credentials_step === true
    });

    var storeCardIconClasses = clsx({
      icon: true,
      "spinner": this.props.currentStep === 'store_card',
      "ss-lightning": this.props.gateway && this.props.gateway.store_card_step === null && this.props.currentStep !== 'store_card',
      "ss-alert": this.props.gateway && this.props.gateway.store_card_step === false,
      "ss-check": this.props.gateway && this.props.gateway.store_card_step === true
    });

    var authorizeIconClasses = clsx({
      icon: true,
      "spinner": this.props.currentStep === 'authorize',
      "ss-lightning": this.props.gateway && this.props.gateway.authorize_step === null && this.props.currentStep !== 'authorize',
      "ss-alert": this.props.gateway && this.props.gateway.authorize_step === false,
      "ss-check": this.props.gateway && this.props.gateway.authorize_step === true
    });

    var captureIconClasses = clsx({
      icon: true,
      "spinner": this.props.currentStep === 'capture',
      "ss-lightning": this.props.gateway && this.props.gateway.capture_step === null && this.props.currentStep !== 'capture',
      "ss-alert": this.props.gateway && this.props.gateway.capture_step === false,
      "ss-check": this.props.gateway && this.props.gateway.capture_step === true
    });

    var voidIconClasses = clsx({
      icon: true,
      "spinner": this.props.currentStep === 'void',
      "ss-lightning": this.props.gateway && this.props.gateway.void_step === null && this.props.currentStep !== 'void',
      "ss-alert": this.props.gateway && this.props.gateway.void_step === false,
      "ss-check": this.props.gateway && this.props.gateway.void_step === true
    });

    var unstoreCardIconClasses = clsx({
      icon: true,
      "spinner": this.props.currentStep === 'unstore_card',
      "ss-lightning": this.props.gateway && this.props.gateway.unstore_card_step === null && this.props.currentStep !== 'unstore_card',
      "ss-alert": this.props.gateway && this.props.gateway.unstore_card_step === false,
      "ss-check": this.props.gateway && this.props.gateway.unstore_card_step === true
    });

    // col classes
    var credentialsColClasses = clsx({
      "col-md-2": true,
      "current": this.props.currentStep == 'credentials',
      "step": true,
      "success": this.props.gateway && this.props.gateway.credentials_step === true,
      "error": this.props.gateway && this.props.gateway.credentials_step === false,
    });

    var storeCardColClasses = clsx({
      "col-md-2": true,
      "current": this.props.currentStep == 'store_card',
      "step": true,
      "success": this.props.gateway && this.props.gateway.store_card_step === true,
      "error": this.props.gateway && this.props.gateway.store_card_step === false,
    });

    var authorizeColClasses = clsx({
      "col-md-2": true,
      "current": this.props.currentStep == 'authorize',
      "step": true,
      "success": this.props.gateway && this.props.gateway.authorize_step === true,
      "error": this.props.gateway && this.props.gateway.authorize_step === false,
    });

    var captureColClasses = clsx({
      "col-md-2": true,
      "current": this.props.currentStep == 'capture',
      "step": true,
      "success": this.props.gateway && this.props.gateway.capture_step === true,
      "error": this.props.gateway && this.props.gateway.capture_step === false,
    });

    var voidColClasses = clsx({
      "col-md-2": true,
      "current": this.props.currentStep == 'void',
      "step": true,
      "success": this.props.gateway && this.props.gateway.void_step === true,
      "error": this.props.gateway && this.props.gateway.void_step === false,
    });

    var unstoreCardColClasses = clsx({
      "col-md-2": true,
      "current": this.props.currentStep == 'unstore_card',
      "step": true,
      "success": this.props.gateway && this.props.gateway.unstore_card_step === true,
      "error": this.props.gateway && this.props.gateway.unstore_card_step === false,
    });

    return (
      <div className="row steps">
        <div className={credentialsColClasses}>
          <div className="status"><div className={credentialsIconClasses} />{I18n.t('verify_credentials')}</div>
          {this.props.gateway && this.props.gateway.void_step !== true && this.props.gateway.credentials_text ? <div className="text">{this.props.gateway.credentials_text}</div> : null}
        </div>
        <div className={storeCardColClasses}>
          <div className="status"><div className={storeCardIconClasses} />{I18n.t('store_card')}</div>
          {this.props.gateway && this.props.gateway.void_step !== true && this.props.gateway.store_card_text ? <div className="text">{this.props.gateway.store_card_text}</div> : null}
        </div>
        <div className={authorizeColClasses}>
          <div className="status"><div className={authorizeIconClasses} />{I18n.t('authorize_payment')}</div>
          {this.props.gateway && this.props.gateway.void_step !== true && this.props.gateway.authorize_text ? <div className="text">{this.props.gateway.authorize_text}</div> : null}
        </div>
        <div className={captureColClasses}>
          <div className="status"><div className={captureIconClasses} />{I18n.t('capture_payment')}</div>
          {this.props.gateway && this.props.gateway.void_step !== true && this.props.gateway.capture_text ? <div className="text">{this.props.gateway.capture_text}</div> : null}
        </div>
        <div className={voidColClasses}>
          <div className="status"><div className={voidIconClasses} />{I18n.t('void_payment')}</div>
          {this.props.gateway && this.props.gateway.void_step !== true && this.props.gateway.void_text ? <div className="text">{this.props.gateway.void_text}</div> : null}
        </div>
        <div className={unstoreCardColClasses}>
          <div className="status"><div className={unstoreCardIconClasses} />{I18n.t('unstore_card')}</div>
          {this.props.gateway && this.props.gateway.void_step !== true && this.props.gateway.unstore_card_text ? <div className="text">{this.props.gateway.unstore_card_text}</div> : null}
        </div>
      </div>
    );
  }
};

export default PaymentGatewayTesterSteps
